var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IG",
    transform: "translate(-1510 -4100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(1510 4100)",
    fill: "none",
    stroke: "#44d62c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M6.379,5.347A3.272,3.272,0,1,0,9.651,8.619,3.267,3.267,0,0,0,6.379,5.347Zm0,5.4A2.127,2.127,0,1,1,8.507,8.619a2.131,2.131,0,0,1-2.127,2.127Zm4.169-5.534a.763.763,0,1,1-.763-.763A.761.761,0,0,1,10.548,5.213Zm2.167.775a3.777,3.777,0,0,0-1.031-2.674A3.8,3.8,0,0,0,9.011,2.283c-1.054-.06-4.212-.06-5.266,0A3.8,3.8,0,0,0,1.071,3.311,3.789,3.789,0,0,0,.04,5.985c-.06,1.054-.06,4.212,0,5.266a3.777,3.777,0,0,0,1.031,2.674,3.807,3.807,0,0,0,2.674,1.031c1.054.06,4.212.06,5.266,0a3.777,3.777,0,0,0,2.674-1.031,3.8,3.8,0,0,0,1.031-2.674c.06-1.054.06-4.209,0-5.263Zm-1.361,6.394a2.154,2.154,0,0,1-1.213,1.213,14.066,14.066,0,0,1-3.762.256,14.176,14.176,0,0,1-3.762-.256A2.154,2.154,0,0,1,1.4,12.381a14.066,14.066,0,0,1-.256-3.762A14.176,14.176,0,0,1,1.4,4.857,2.154,2.154,0,0,1,2.617,3.644a14.066,14.066,0,0,1,3.762-.256,14.176,14.176,0,0,1,3.762.256,2.154,2.154,0,0,1,1.213,1.213,14.066,14.066,0,0,1,.256,3.762A14.058,14.058,0,0,1,11.354,12.381Z",
    transform: "translate(1516.631 4104.389)",
    fill: "#44d62c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b1925c4151871a990bd7384aaf384218.svg";
export { ForwardRef as ReactComponent };